import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useClientColyseus } from "../../Contexts/ClientColyseusContext";
import PlayerNamePrompt from "./PlayerNamePrompt";

const DeepLinkJoinRoom = () => {
  const { roomId } = useParams();
  const { joinById, room } = useClientColyseus();
  const history = useHistory();
  const [playerName, setPlayerName] = useState("");
  const [joining, setJoining] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (room) {
      // Redirect to the main multiplayer/game page after successful join
      history.replace("/multiplayer");
    }
  }, [room, history]);

  const handleNameSubmit = async (name) => {
    setPlayerName(name);
    setJoining(true);
    setError("");
    let didTimeout = false;
    // Set a timeout for joining (10 seconds)
    const timeoutId = setTimeout(() => {
      didTimeout = true;
      setError("Joining timed out. The server may be unreachable. Please try again or check your connection.");
      setJoining(false);
      setPlayerName("");
    }, 10000);
    try {
      await joinById(roomId, { name });
      if (!didTimeout) {
        clearTimeout(timeoutId);
        // Success: room state will update and useEffect will redirect
      }
    } catch (err) {
      if (!didTimeout) {
        clearTimeout(timeoutId);
        setError(err?.message || "Failed to join room. Please try again.");
        setJoining(false);
        setPlayerName("");
      }
    }
  };


  const handleRetry = () => {
    setError("");
    setPlayerName("");
    setJoining(false);
  };

  if (!playerName && !joining) {
    return <PlayerNamePrompt onSubmit={handleNameSubmit} />;
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen p-8">
        <h2 className="text-2xl font-bold text-red-700 mb-4">Failed to Join Room</h2>
        <div className="text-gray-600 mb-4">{error}</div>
        <div className="flex gap-4">
          <button
            className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
            onClick={handleRetry}
          >
            Try Again
          </button>
          <button
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
            onClick={() => history.replace("/multiplayer")}
          >
            Back to Multiplayer Lobby
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-8">
      <h2 className="text-2xl font-bold text-indigo-700 mb-4">Joining Room...</h2>
      <div className="text-gray-600">Please wait while we connect you to the room.</div>
    </div>
  );
};

export default DeepLinkJoinRoom;
